import { render, staticRenderFns } from "./Cultivate.vue?vue&type=template&id=4776a952&scoped=true&"
import script from "./Cultivate.vue?vue&type=script&lang=js&"
export * from "./Cultivate.vue?vue&type=script&lang=js&"
import style0 from "./Cultivate.vue?vue&type=style&index=0&id=4776a952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4776a952",
  null
  
)

export default component.exports